export const CHECKOUT_CONSTANTS = {
  CHECKOUT: 'checkout',
  FORM: 'form',
  SOURCE: 'source',
  REDIRECT_URL: 'redirectUrl',
  CUSTOMER_ID: 'customerId',
  DELIVERY_ADDRESS: 'deliveryAddress',
  PAYMENT_SERVICE: 'paymentService',
  DELIVERY_SERVICE: 'shippingService',
  REFERENCE: 'reference',
  COMMENT: 'comment',
  CLIENT_DATA: 'clientData',
  TOS_AGREED: 'tosAgreed',
  CHECKOUT_TERMS_URL: 'CHECKOUT_TERMS_URL',
  CHECKOUT_PRIVACY_URL: 'CHECKOUT_PRIVACY_URL',
}

export const CHECKOUT_PATHS = {
  ROOT: [CHECKOUT_CONSTANTS.CHECKOUT],
  FORM: [CHECKOUT_CONSTANTS.CHECKOUT, CHECKOUT_CONSTANTS.FORM],
  SOURCE: [CHECKOUT_CONSTANTS.CHECKOUT, CHECKOUT_CONSTANTS.SOURCE],
  // Source
  REDIRECT_URL: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.SOURCE,
    CHECKOUT_CONSTANTS.REDIRECT_URL,
  ],
  CHECKOUT_TERMS_URL: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.SOURCE,
    CHECKOUT_CONSTANTS.CHECKOUT_TERMS_URL,
  ],
  CHECKOUT_PRIVACY_URL: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.SOURCE,
    CHECKOUT_CONSTANTS.CHECKOUT_PRIVACY_URL,
  ],
  // Form
  CUSTOMER_ID: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.FORM,
    CHECKOUT_CONSTANTS.CUSTOMER_ID,
  ],
  // DELIVERY_ADDRESS: [
  //   CHECKOUT_CONSTANTS.CHECKOUT,
  //   CHECKOUT_CONSTANTS.FORM,
  //   CHECKOUT_CONSTANTS.DELIVERY_ADDRESS,
  // ],
  BILLING_ADDRESS: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.FORM,
    CHECKOUT_CONSTANTS.BILLING_ADDRESS,
  ],
  PAYMENT_SERVICE: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.FORM,
    CHECKOUT_CONSTANTS.PAYMENT_SERVICE,
  ],
  DELIVERY_SERVICE: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.FORM,
    CHECKOUT_CONSTANTS.DELIVERY_SERVICE,
  ],
  // REFERENCE: [CHECKOUT_CONSTANTS.CHECKOUT, CHECKOUT_CONSTANTS.FORM, CHECKOUT_CONSTANTS.REFERENCE],
  // COMMENT: [CHECKOUT_CONSTANTS.CHECKOUT, CHECKOUT_CONSTANTS.FORM, CHECKOUT_CONSTANTS.COMMENT],
  CLIENT_DATA: [
    CHECKOUT_CONSTANTS.CHECKOUT,
    CHECKOUT_CONSTANTS.FORM,
    CHECKOUT_CONSTANTS.CLIENT_DATA,
  ],
  TOS_AGREED: [CHECKOUT_CONSTANTS.CHECKOUT, CHECKOUT_CONSTANTS.FORM, CHECKOUT_CONSTANTS.TOS_AGREED],
}
